// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"1cc6f9a7","613":"681435a8"}[chunkId] + ".1793856400255.chunk.css";
};